import { css } from '@emotion/react'
import styled from '@emotion/styled'

const COLOR_MAP = {
  info: {
    background: 'b100',
    icon: 'b600'
  },
  warning: {
    background: 'y100',
    icon: 'y600'
  },
  success: {
    background: 'g100',
    icon: 'g600'
  },
  critical: {
    background: 'r100',
    icon: 'r600'
  }
}

const baseStyles = ({ theme, type = 'info' }) => {
  const { background, icon } = COLOR_MAP[type]

  return css`
    label: alert-message;

    display: flex;
    align-items: flex-start;

    background: ${theme.colors[background]};

    border-radius: ${theme.borderRadius.giga};
    box-shadow: 0px 0px 0px 1px rgba(186, 182, 188, 0.07),
      0px 0px 1px ${theme.colors.shadow}, 0px 2px 2px rgba(161, 155, 162, 0.07);

    margin-top: ${theme.spacings.byte};
    padding: ${theme.spacings.kilo};

    svg {
      margin-top: 2px;
      color: ${theme.colors[icon]};
      flex-shrink: 0;
    }
  `
}

const stretchStyles = ({ isStretch }) =>
  isStretch &&
  css`
    label: alert-message--stretch;

    width: 100%;
  `

const messageStyles = ({ theme }) => css`
  label: alert-message__message;

  margin-left: ${theme.spacings.byte};
`

export const AlertMessage = styled('div')(baseStyles, stretchStyles)
export const Message = styled('div')(messageStyles)
